import type { Dayjs } from 'dayjs';
import type { TimePickerProps } from '@mui/x-date-pickers';
import type { TextFieldProps } from '@mui/material/TextField';

import dayjs from 'dayjs';
import { Controller, useFormContext } from 'react-hook-form';

import { TimePicker } from '@mui/x-date-pickers';

import { formatPatterns } from 'src/utils/format-time';

// ----------------------------------------------------------------------

type RHFTimePickerProps = TimePickerProps<Dayjs> & {
  name: string;
  valueAsString?: boolean;
};

export function RHFTimePicker({ name, valueAsString, slotProps, ...other }: RHFTimePickerProps) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TimePicker
          {...field}
          value={dayjs(field.value)}
          onChange={(newValue) => {
            if (valueAsString) {
              field.onChange(dayjs(newValue).toDate());
            } else {
              field.onChange(dayjs(newValue).toDate().getTime());
            }
          }}
          format={formatPatterns.time}
          slotProps={{
            ...slotProps,
            textField: {
              fullWidth: true,
              error: !!error,
              helperText: error?.message ?? (slotProps?.textField as TextFieldProps)?.helperText,
              ...slotProps?.textField,
            },
          }}
          {...other}
        />
      )}
    />
  );
}
